const vaginalDischarge = [

    {  
    label:"Amount",
    controlType:"radio button",
    options:["Trace", "Smear", "Soaking", "Flooding"]
    },

    {
    label:"Colour(s)",
    controlType:"checkbox group",
    options:["Clear","White", "Green", "Brown", "Other"]
    },

    {
    label:"Blood stained",
    controlType:"radio button",
    options:["Yes", "No"]
    },

    {
    label:"Frequency",
    controlType:"radio button",
    options:["Every day","Most days", "Weekly", "Every couple of weeks", "Monthly", "Occasionally"]
    },

    {
    label:"Present for several:",
    controlType:"radio button",
    options:["Days","Weeks","Months","Years"]
    }

]
 export default vaginalDischarge